/* PDP buy box update, October 2026 (client email 2026-10-12). Companion stylesheet: assets/pdp-buybox.css.
   1. "Ships Today / Ships Tomorrow / Ships Monday" row (sections/main-product.liquid, [data-pdp-ships]).
      Rules from the client, evaluated in the store's local time zone (data-ships-timezone, default America/New_York),
      cut-off 2pm (data-ships-cutoff, "HH:MM", 24h):
        Ships Today     -> Monday to Friday before the cut-off
        Ships Tomorrow  -> Monday to Thursday after the cut-off, or Sunday after the cut-off
        Ships Monday    -> from Friday at the cut-off until Sunday just before the cut-off (includes all of Saturday)
      The label is computed in the browser because Shopify caches rendered pages, so Liquid's "now" is not reliable.
      The row stays hidden until the label is set, so a script failure shows nothing rather than something wrong.
      QA: window.MGShips.label({ day: 5, minutes: 14 * 60 }) -> "Ships Monday" (day: 0 = Sunday ... 6 = Saturday).
   2. Buy Now, Pay Later "Learn more" overlay (#pdp-bnpl-modal). */
(function () {
  'use strict';

  var DAY_INDEX = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

  function storeNow(timeZone) {
    try {
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: timeZone,
        weekday: 'short',
        hour: 'numeric',
        minute: 'numeric',
        hourCycle: 'h23'
      }).formatToParts(new Date());
      var map = {};
      for (var i = 0; i < parts.length; i++) map[parts[i].type] = parts[i].value;
      var hour = parseInt(map.hour, 10);
      if (hour === 24) hour = 0; // some engines report midnight as 24
      var day = DAY_INDEX[map.weekday];
      var minutes = hour * 60 + parseInt(map.minute, 10);
      if (typeof day !== 'number' || isNaN(minutes)) throw new Error('bad parts');
      return { day: day, minutes: minutes };
    } catch (e) {
      // Intl time zone support missing: fall back to the visitor's clock.
      var d = new Date();
      return { day: d.getDay(), minutes: d.getHours() * 60 + d.getMinutes() };
    }
  }

  function shipsLabel(t, cutoff) {
    if (typeof cutoff !== 'number') cutoff = 14 * 60;
    var weekday = t.day >= 1 && t.day <= 5;
    if (weekday && t.minutes < cutoff) return 'Ships Today';
    var monToThuOrSun = (t.day >= 1 && t.day <= 4) || t.day === 0;
    if (monToThuOrSun && t.minutes >= cutoff) return 'Ships Tomorrow';
    return 'Ships Monday'; // Friday from the cut-off, all Saturday, Sunday before the cut-off
  }

  function parseCutoff(value) {
    var m = /^(\d{1,2}):(\d{2})$/.exec(value || '');
    if (!m) return 14 * 60;
    return parseInt(m[1], 10) * 60 + parseInt(m[2], 10);
  }

  function initShips() {
    var rows = document.querySelectorAll('[data-pdp-ships]');
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      var label = row.querySelector('[data-pdp-ships-label]');
      if (!label) continue;
      var tz = row.getAttribute('data-ships-timezone') || 'America/New_York';
      var cutoff = parseCutoff(row.getAttribute('data-ships-cutoff'));
      label.textContent = shipsLabel(storeNow(tz), cutoff);
      row.hidden = false;
    }
  }

  function initBnplModal() {
    var modal = document.getElementById('pdp-bnpl-modal');
    if (!modal) return;
    var box = modal.querySelector('.pdp-modal-box');
    var closeBtn = modal.querySelector('.pdp-modal-close');
    var lastFocus = null;

    function focusables() {
      return box.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    }
    function open() {
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      (closeBtn || box).focus();
    }
    function close() {
      if (modal.hidden) return;
      modal.hidden = true;
      document.documentElement.style.overflow = '';
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    var triggers = document.querySelectorAll('[data-bnpl-learn]');
    for (var i = 0; i < triggers.length; i++) {
      triggers[i].addEventListener('click', function (e) { e.preventDefault(); open(); });
    }
    var closers = modal.querySelectorAll('[data-pdp-modal-close]');
    for (var j = 0; j < closers.length; j++) {
      closers[j].addEventListener('click', close);
    }
    document.addEventListener('keydown', function (e) {
      if (modal.hidden) return;
      if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close(); return; }
      if (e.key === 'Tab') {
        var items = focusables();
        if (!items.length) return;
        var first = items[0], last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }

  function init() {
    initShips();
    initBnplModal();
  }

  window.MGShips = { label: shipsLabel, now: storeNow };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
